import { login } from '@/js/api/auth.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify } from '@/js/notification.ts';

export function initLoginForm(): void {
  const form = document.querySelector<HTMLFormElement>('.js-form-login');
  if (!form) {
    return;
  }

  form.addEventListener('submit', handleLoginFormSubmit);

  function handleLoginFormSubmit(event: Event): void {
    event.preventDefault();
    if (!form) {
      return;
    }
    void loginFormAsync(form);
  }

  async function loginFormAsync(form: HTMLFormElement): Promise<void> {
    const formData = new FormData(form);

    try {
      const response = await login(formData);
      if (response.data?.success && (response.data.redirect_url != null)) {
        window.location.href = response.data.redirect_url;
      }
      else {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
      }
    }
    catch (error: unknown) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
